export const APP_NAME = 'easiibill';
export const APP_TAGLINE = 'Professional Invoicing Made Easy';
export const APP_SLOGAN = 'Create. Customize. Invoice.';

export const LIMITS = {
  maxLineItems: 500,
  maxItemNameLength: 300,
  maxItemDescriptionLength: 5000,
  maxNotesLength: 10_000,
  maxAdjustments: 10,
  maxCustomFields: 20,
  maxTaxesPerLine: 5,
  maxPageSize: 100,
  defaultPageSize: 25,
  maxBulkIds: 100,
  maxBulkDownload: 50,
  maxCsvRows: 5000,
  maxCsvBytes: 2 * 1024 * 1024,
  maxTemplateBytes: 512 * 1024,
  maxTemplateNodes: 400,
  maxQuantity: '1000000000',
  maxUnitPrice: '1000000000000',
  maxMoney: '1000000000000',
} as const;

export const UPLOAD_LIMITS = {
  /** Max size per asset kind, in bytes. */
  logo: 2 * 1024 * 1024,
  signature: 2 * 1024 * 1024,
  stamp: 2 * 1024 * 1024,
  image: 5 * 1024 * 1024,
  attachment: 10 * 1024 * 1024,
} as const;

export const ASSET_KINDS = ['logo', 'signature', 'stamp', 'image', 'attachment'] as const;
export type AssetKind = (typeof ASSET_KINDS)[number];

/** Image MIME types that can be embedded in templates and PDFs. */
export const TEMPLATE_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg'] as const;
export const ATTACHMENT_MIME_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'] as const;

export const SESSION = {
  cookieName: 'eb_session',
  csrfCookieName: 'eb_csrf',
  csrfHeaderName: 'x-csrf-token',
  businessHeaderName: 'x-business-id',
  /** Sent by the native apps, which authenticate with `Authorization: Bearer` instead of cookies. */
  clientHeaderName: 'x-easiibill-client',
  ttlSeconds: 60 * 60 * 24 * 30,
  shortTtlSeconds: 60 * 60 * 12,
  touchIntervalSeconds: 5 * 60,
} as const;

export const AUTH = {
  passwordMinLength: 8,
  passwordMaxLength: 128,
  pbkdf2Iterations: 100_000,
  maxFailedLogins: 5,
  lockoutMinutes: 15,
  emailVerificationTtlSeconds: 60 * 60 * 24,
  passwordResetTtlSeconds: 60 * 60,
} as const;
